import React, { Component } from "react";
import { browserHistory } from "react-router";
import { connect } from 'react-redux';

import ProjectForm from "./ProjectForm";

import { saveProject } from "../webAPI/MKSService";

class ProjectFormContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			fields: {
				name					: "",
				city					: "",
				date_of_receipt			: "",
				email					: "",
				comment					: "",
				surface_treatment_code	: "LN",
				is_protected			: false,
				a2p						: false,
				project_type_id			: 1
			}
		};

		this.handleTextFieldChange		= this.handleTextFieldChange.bind(this);
		this.handleDateFieldBlur		= this.handleDateFieldBlur.bind(this);
		this.handleRadioButtonChange	= this.handleRadioButtonChange.bind(this);
		this.handleSwitchChange			= this.handleSwitchChange.bind(this);
		this.handleSubmit				= this.handleSubmit.bind(this);
	}

	componentWillMount() {
		if(this.props.project) {
			/* Format date to display */
			const splits = this.props.project.date_of_receipt.split("-");
			const formatedDate = `${splits[2]}/${splits[1]}/${splits[0]}`;

			const isDuplicationMode = this.props.formMode === "duplication";
			let name = this.props.project.name;
			if(isDuplicationMode) {
				name = `${name} (copie)`;
			}

			this.setState({
				fields: {
					...this.props.project,
					name,
					date_of_receipt: formatedDate
				}
			});
		} else {
			/* prefill email */
			const { user } = this.props;
			const email = user.email;
			this.setState({
				fields: {
					...this.state.fields,
					email
				}
			});
		}
	}

	render() {
		const isDuplicationMode = this.props.formMode === "duplication";
		const isEditionMode = this.props.formMode === "edition";
		const iscreationMode = this.props.formMode === "creation";
		//const isNewProject = !this.props.project;

		const headerText =
			isDuplicationMode ? "Duplication de projet"
			: isEditionMode ? "Edition de projet"
			: "Nouveau Projet";
		//const headerText = isNewProject ? "Nouveau projet" : "Edition de projet";

		const submitButtonText =
			isDuplicationMode ? "Dupliquer le projet"
			: isEditionMode ? "Enregistrer les modifications"
			: "Démarrer le projet";
		//const submitButtonText = isNewProject ? "Démarrer le projet" : "Enregistrer les modifications";

		return (
			<ProjectForm
				headerText={headerText}
				submitButtonText={submitButtonText}
				fields={this.state.fields}
				loading={this.state.loading}
				handleTextFieldChange={this.handleTextFieldChange}
				handleDateFieldBlur={this.handleDateFieldBlur}
				handleRadioButtonChange={this.handleRadioButtonChange}
				handleSwitchChange={this.handleSwitchChange}
				handleSubmit={this.handleSubmit}
				handleCancel={this.props.onClose} />
		);
	}

	handleTextFieldChange(field, value) {
		const newFieldsState = Object.assign({},
			this.state.fields,
			{ [field]: value });
		this.setState({ fields: newFieldsState }
		);
	}

	handleDateFieldBlur(value) {
		const newFieldsState = Object.assign({},
			this.state.fields,
			{ date_of_receipt: value }
		);
		this.setState({ fields: newFieldsState });
	}

	handleRadioButtonChange(field, value) {
		const newFieldsState = Object.assign({},
			this.state.fields,
			{ [field]: value }
		);
		this.setState({ fields: newFieldsState });
	}

	handleSwitchChange(field, event) {
		const newFieldsState = Object.assign({},
			this.state.fields,
			{ [field]: event.target.checked }
		);
		this.setState({ fields: newFieldsState });
	}

	handleSubmit() {
		this.setState({ loading: true });

		/* Format date to send */
		let formatedDate = this.props.fields;
		if(this.state.fields.date_of_receipt) {
			const splits = this.state.fields.date_of_receipt.split("/");
			formatedDate = `${splits[2]}-${splits[1]}-${splits[0]}`;
		}

		const fields = Object.assign({},
			this.state.fields,
			{ date_of_receipt: formatedDate }
		);

		const isDuplicationMode = this.props.formMode === "duplication";
		const projectId = fields.project_id
		if(isDuplicationMode) {
			delete fields["project_id"];
			fields.project_id_to_clone = projectId;
		}

		// Why null, It shoul be project ID ?
		saveProject(fields).then(
			() => {
				this.setState({ loading: false });
			},
			(result) => {
				if(isDuplicationMode) {
					this.props.dispatch({
						type: "CLONE_PROJECT_SUCCESS",
						result
					});
					browserHistory.push("/app/project/" + encodeURIComponent(result.project_id) + "/plan")
				} else {
					this.props.dispatch({
						type: "SAVE_PROJECT_SUCCESS",
						oldProjectId: this.props.project ? this.props.project.project_id : null,
						result
					});
					this.props.onClose();
					const isNewProject = !this.props.project;
					if(isNewProject) {
						browserHistory.push("/app/project/" + encodeURIComponent(result.project_id) + "/clone-v2")
					}
				}
			}
		);
	}
}

function mapStateToProps(state) {
	return {
		user: state.user
	};
}

export default connect(mapStateToProps)(ProjectFormContainer);



// WEBPACK FOOTER //
// ./src/js/project-v2/ProjectFormContainer.js